/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export const businessCurrencyEnum = {
  BRL: 'BRL',
  MXN: 'MXN',
  COP: 'COP',
  CLP: 'CLP',
  ARS: 'ARS',
  PEN: 'PEN',
  UYU: 'UYU',
  PYG: 'PYG',
  BOB: 'BOB',
  CRC: 'CRC',
  DOP: 'DOP',
  GTQ: 'GTQ',
  HNL: 'HNL',
  NIO: 'NIO',
  PAB: 'PAB',
  VES: 'VES',
  CUP: 'CUP',
  HTG: 'HTG',
  USD: 'USD',
  EUR: 'EUR',
} as const;

export type BusinessCurrencyEnumKey =
  (typeof businessCurrencyEnum)[keyof typeof businessCurrencyEnum];

export type BusinessCurrency = BusinessCurrencyEnumKey;
